import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.employeeProbationValidation = function () {
    const dictonary = {
      custom: {
        DateInt: {
          required: () => t.t(dictEnum.LBL_AppraisalPeriod) + t.t(dictEnum.WARN_IsRequired)
        },
        PorbResult: {
          required: () => t.t(dictEnum.LBL_Status) + t.t(dictEnum.WARN_IsRequired)
        },
        DateEff: {
          required: () => t.t(dictEnum.LBL_DateEffective) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProbation/S070200-EmployeeProbationValidation.js